var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaiseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.723,
    height: 25.717,
    viewBox: "0 0 25.723 25.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-raise",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M11.18,93.142H.864a.864.864,0,1,0,0,1.729H11.18a.864.864,0,1,0,0-1.729Z",
    transform: "translate(0 -69.654)",
    fill: "#696969",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M62.332,39.115l-4.979-3.239a.864.864,0,0,0-1.2.253l-5.748,8.835a.868.868,0,0,0-.139.453l-.125,5.637a.865.865,0,0,0,1.232.8l5.1-2.4a.865.865,0,0,0,.357-.311l5.747-8.835a.865.865,0,0,0-.253-1.2ZM55.523,48,51.9,49.7l.088-4,5.142-7.9,3.53,2.3Z",
    transform: "translate(-37.504 -26.719)",
    fill: "#696969",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M11.826,14.662H1.729V1.7h14.38V8.3a.865.865,0,1,0,1.729,0V.835a.865.865,0,0,0-.865-.864H.865A.865.865,0,0,0,0,.835V15.527a.864.864,0,0,0,.865.864H11.826a.865.865,0,0,0,0-1.729Z",
    transform: "translate(0 0.029)",
    fill: "#696969",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M.864,83.238H10.883a.865.865,0,1,0,0-1.729H.864a.865.865,0,0,0,0,1.729Z",
    transform: "translate(0 -60.953)",
    fill: "#696969",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M.864,71.606H10.883a.865.865,0,1,0,0-1.729H.864a.865.865,0,0,0,0,1.729Z",
    transform: "translate(0 -52.254)",
    fill: "#696969",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseIcon);
export default __webpack_public_path__ + "static/media/raiseIcon.7af5a64c1de4cd3fbf4457fd572e60fa.svg";
export { ForwardRef as ReactComponent };